
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4DMt9", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=de.05ff6033.js.map
